import { FeeType, Price } from "../common";

export const FeeTypeText: Record<FeeType, string> = {
  [FeeType.DELIVERY]: "Frais de livraison",
  [FeeType.SMALL_ORDER]: "Frais de petite commande",
  [FeeType.SERVICE]: "Frais de service",
};

export interface Fee {
  type: FeeType;
  value: Price;
}

export interface PaymentInfo {
  totalPrice: Price;
  orderPrice: Price;
  fees: Fee[];
}
